<template>
    <v-menu v-if="hasItems">
        <template v-slot:activator="{ props }">
            <v-btn color="primary" variant="tonal" v-bind="props">
                {{ buttonText }}
            </v-btn>
        </template>
        <v-list>
            <v-list-item v-for="item in rootItems"
                         :key="'root-' + item.CompanyId"
                         @click="selectItem(item)">
                <v-list-item-title>{{ item.Name }}</v-list-item-title>
            </v-list-item>
            <v-list-group v-for="group in categoryGroups"
                          :key="group.Category"
                          :value="group.Category">
                <template v-slot:activator="{ props }">
                    <v-list-item v-bind="props" :title="group.Category"></v-list-item>
                </template>
                <v-list-item v-for="item in group.Items"
                             :key="'group-' + item.CompanyId"
                             @click="selectItem(item)">
                    <v-list-item-title>{{ item.Name }}</v-list-item-title>
                </v-list-item>
            </v-list-group>
        </v-list>
    </v-menu>
</template>

<script>
    export default {
        name: 'example-company-menu',
        props: {
            items: {
                type: Array,
                default: () => []
            },
            buttonText: {
                type: String,
                default: 'Skapa från exempel'
            }
        },
        computed: {
            hasItems() {
                return this.items != null && this.items.length > 0;
            },
            rootItems() {
                return (this.items || []).filter(item => !item.Category);
            },
            categoryGroups() {
                const groups = {};
                (this.items || []).forEach(item => {
                    if (!item.Category) {
                        return;
                    }

                    if (!groups[item.Category]) {
                        groups[item.Category] = [];
                    }

                    groups[item.Category].push(item);
                });

                return Object.keys(groups).map(category => ({
                    Category: category,
                    Items: groups[category]
                }));
            }
        },
        methods: {
            selectItem(item) {
                this.$emit('select', item);
            }
        }
    }
</script>
